import { useState, useEffect } from "react";

const usePermissions = () => {
  const [permissions, setPermissions] = useState([]);
  const [userType, setUserType] = useState("");
  const [loading, setLoading] = useState(true);

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchPermissions = () => {
      try {
        const storedData = localStorage.getItem("userData");
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          setUserData(parsedData);
          const rawPerms = parsedData.role?.permissions || parsedData.permissions || [];
          const perms = Array.isArray(rawPerms) ? rawPerms : [];
          setPermissions(perms);
          
          // Extract role name correctly (it could be a string or an object)
          const roleName = typeof parsedData.role === 'string' 
            ? parsedData.role 
            : (parsedData.role?.roleName || parsedData.userType || "");
            
          setUserType(roleName);
        }
      } catch (error) {
        console.error("Error reading permissions from localStorage:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
    
    // Listen for storage changes in case of login/logout in other tabs
    window.addEventListener('storage', fetchPermissions);
    return () => window.removeEventListener('storage', fetchPermissions);
  }, []);

  const hasPermission = (moduleName, action = "view") => {
    // Admin always has full access
    if (userType?.toUpperCase() === "ADMIN" || userType?.toUpperCase() === "SUPER ADMIN") return true;
    
    if (loading) return false;

    // Find the module in permissions array
    // Module names in DB are often lowercase with underscores (e.g., "user_roles")
    const module = permissions.find((perm) => {
      const dbModule = perm.module.toLowerCase();
      const checkModule = moduleName.toLowerCase();
      return (
        dbModule === checkModule ||
        dbModule === checkModule.replace(/ /g, "_").replace(/-/g, "_") ||
        dbModule.replace(/_/g, " ") === checkModule
      );
    });

    if (!module) return false;

    // Check if the specific action is permitted
    return module[action] === true;
  };

  return { hasPermission, userType, loading, userData };
};

export default usePermissions;
